
// @ts-nocheck
import locale_sv_45SE_46json_04174bff from "#nuxt-i18n/04174bff";
import locale_sv_45SE_46js_55d36157 from "#nuxt-i18n/55d36157";
import locale_en_45EU_46json_a19b0b80 from "#nuxt-i18n/a19b0b80";
import locale_en_45EU_46js_d96e2e6f from "#nuxt-i18n/d96e2e6f";

export const localeCodes =  [
  "sv-SE",
  "en-EU"
]

export const localeLoaders = {
  "sv-SE": [
    {
      key: "locale_sv_45SE_46json_04174bff",
      load: () => Promise.resolve(locale_sv_45SE_46json_04174bff),
      cache: true
    },
    {
      key: "locale_sv_45SE_46js_55d36157",
      load: () => Promise.resolve(locale_sv_45SE_46js_55d36157),
      cache: true
    }
  ],
  "en-EU": [
    {
      key: "locale_en_45EU_46json_a19b0b80",
      load: () => Promise.resolve(locale_en_45EU_46json_a19b0b80),
      cache: true
    },
    {
      key: "locale_en_45EU_46js_d96e2e6f",
      load: () => Promise.resolve(locale_en_45EU_46js_d96e2e6f),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/9e4afb6c" /* webpackChunkName: "config_i18n_46config_46js_9e4afb6c" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "sv-SE",
      name: "Svenska",
      files: [
        {
          path: "/service/i18n/locales/dsc/sv-SE.json",
          cache: undefined
        },
        {
          path: "/service/i18n/locales/sv-SE.js",
          cache: undefined
        }
      ]
    },
    {
      code: "en-EU",
      name: "English",
      files: [
        {
          path: "/service/i18n/locales/dsc/en-EU.json",
          cache: undefined
        },
        {
          path: "/service/i18n/locales/en-EU.js",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "sv-SE",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: true,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  sync: true,
  i18nModules: [
    {
      langDir: "./i18n/locales/dsc/",
      locales: [
        {
          code: "en-EU",
          name: "English"
        },
        {
          code: "sv-SE",
          name: "Svenska"
        }
      ]
    }
  ]
}

export const normalizedLocales = [
  {
    code: "sv-SE",
    name: "Svenska",
    files: [
      {
        path: "/service/i18n/locales/dsc/sv-SE.json",
        cache: undefined
      },
      {
        path: "/service/i18n/locales/sv-SE.js",
        cache: undefined
      }
    ]
  },
  {
    code: "en-EU",
    name: "English",
    files: [
      {
        path: "/service/i18n/locales/dsc/en-EU.json",
        cache: undefined
      },
      {
        path: "/service/i18n/locales/en-EU.js",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/